import type { HandSet, PackageVersion } from '@/lib/task-runs'
import { fmtDateTime } from '@/lib/format'
import './package-badges.css'

export function packageLabels(version: PackageVersion): string[] {
  const status = version.status
  return [version.latest ? 'Latest' : '', status?.kind === 'hand' ? 'Set by hand' : '', status?.kind === 'wip' ? 'Work in Progress' : '',
    status?.kind === 'submission' ? 'Agent submission' : '', status?.kind === 'unknown' ? 'Submission history unavailable' : '', status?.unreviewed ? 'unreviewed' : '',
    status?.review_unavailable ? 'Review status unavailable' : '', status?.published ? 'published' : '', status?.rejected ? 'rejected' : ''].filter(Boolean)
}

export function handSetText(hand: HandSet) {
  return `Set by ${hand.set_by.name || hand.set_by.user_id} on ${fmtDateTime(hand.set_at)}${hand.note ? `: ${hand.note}` : ''}`
}

export function PackageBadges({ version }: { version: PackageVersion }) {
  const hand = version.status?.hand
  return <span className="package-badges">{packageLabels(version).map(label => <span className={`package-badge ${label.replaceAll(' ', '-').toLowerCase()}`} key={label}
    title={label === 'Review status unavailable' ? 'The referenced review snapshot is missing in this environment; its review status cannot be verified.'
      : label === 'Submission history unavailable' ? 'Rollout history exists, but no matching website submission record was found for this package.'
      : label === 'Set by hand' && hand ? `${handSetText(hand)}. Not reviewed through authoring.` : undefined}>{label}</span>)}</span>
}
